import { Alert, Dialog, Popover, Skeleton, Stack, useBreakpointDown } from '@all-manager/design-system-v2';
import { useGetEventById } from '../../features/events/api/useGetEventById';
import EventContent from '../EventContent';

type Props = {
  onClose: () => void;
  eventId: string;
  anchorEl: HTMLElement | null;
};

const SKELETON_WIDTH = 320;

export default function ViewEventModal(props: Props) {
  const isMobile = useBreakpointDown('sm');
  const { data, isLoading } = useGetEventById(props.eventId);

  function renderContent(hideTitle: boolean) {
    if (isLoading) {
      return (
        <Stack spacing={1} aria-busy="true" aria-label="Chargement de l'événement">
          <Skeleton variant="text" width={SKELETON_WIDTH * 0.4} />
          <Skeleton variant="text" width={SKELETON_WIDTH} />
          <Skeleton variant="text" width={SKELETON_WIDTH * 0.6} />
        </Stack>
      );
    }

    if (!data) {
      return (
        <Alert severity="error">
          L'événement n'a pas pu être chargé. Fermez puis rouvrez-le pour réessayer.
        </Alert>
      );
    }

    return (
      <EventContent
        event={data}
        hideTitle={hideTitle}
        onClose={hideTitle ? undefined : props.onClose}
        onDeleted={props.onClose}
      />
    );
  }

  if (isMobile) {
    return (
      <Dialog
        open
        onClose={() => props.onClose()}
        maxWidth="sm"
        fullWidth
        title={data?.title ?? 'Événement'}
        closeLabel="Fermer"
      >
        {renderContent(true)}
      </Dialog>
    );
  }

  return (
    <Popover
      open={Boolean(props.anchorEl)}
      anchorEl={props.anchorEl}
      onClose={() => props.onClose()}
      aria-label={data?.title ?? 'Événement'}
    >
      {renderContent(false)}
    </Popover>
  );
}
